<template>
    <div>
        <div class="row tw-mb-4">
            <div class="col-sm-6">
                <label
                    for=""
                    class="package--title"
                    >วันที่เริ่มต้น</label
                >
                <div class="package--detail">
                    {{ packageShop.date_from }}
                </div>
            </div>
            <div class="col-sm-6">
                <label
                    for=""
                    class="package--title"
                    >วันที่สิ้นสิ้นสุด</label
                >
                <div class="package--detail">
                    {{ packageShop.date_to }}
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-6">
                <label
                    for=""
                    class="package--title"
                    >ชื่อแพ็กเกจ</label
                >
                <div class="package--detail">
                    {{ packageShop.name }}
                </div>
            </div>
            <div class="col-sm-6">
                <label
                    for=""
                    class="package--title"
                    >สถานะ</label
                >
                <div class="package--detail">

                    <span class="badge badge-success ml-0" v-if="packageShop.status_active == 'ACTIVE'">
                        {{ packageShop.status_active }}
                    </span>
                    <span class="badge badge-secondary ml-0" v-else>
                        {{ packageShop.status_active }}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from "moment";
export default {
    props: ["shop"],
    data() {
        return {
            packageShop: {}
        };
    },
    mounted() {
        this.getPackageShop();
    },
    methods: {
        async getPackageShop() {
            const url = `/ajax/s/${this.shop}/package`;
            await axios.get(url).then(res => {
                const {
                    package_plan,
                    date_from,
                    date_to,
                    status_active
                } = res.data.package;

                this.packageShop = {
                    name: package_plan.name,
                    date_from: moment(date_from).format("DD-MM-YYYY"),
                    date_to: moment(date_to).format("DD-MM-YYYY"),
                    status_active
                };
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.package--title {
    @apply tw-mb-0 tw-text-sm tw-font-normal;
    color: var(--primary-color2)
}
.package--detail {
    @apply tw-text-lg;
}
</style>
